import { Button, Modal } from "antd";
import "./contextModal.css";
import { memo, useEffect, useMemo } from "react";
import { useGenerateContextDataMutation } from "../../service/apiSlices/workbench";
import { transformNodesToQA } from "../../utilities/Nodes/getConnectedChildNodes";
import { ContextModalProps } from "../../utilities/types/common";
import useDebounce from "../../hooks/useDebounce";
import { useFlowDataContext } from "../../context/workbench/FlowDataContext";
import { useModelDetailsContext } from "../../context/workbench/ModelDetailsContex";

const ContextModal = ({ visible, onCancel, title, content, onConfirm, cancelText, okText }: ContextModalProps) => {
    const flowDataContext = useFlowDataContext();

    const [generateContextData] = useGenerateContextDataMutation();
    const { setModelGenerateContextData, handleBlur, modelGenerateContextData } = useModelDetailsContext();
    const debouncedValue = useDebounce(modelGenerateContextData, 500);

    const result = useMemo(() => transformNodesToQA(flowDataContext?.nodes, flowDataContext?.edges), [flowDataContext?.edges, flowDataContext?.nodes]);

    const payload = {
        format_type: 2,
        input_data: result
    }

    useEffect(() => {
        if (visible) {
            generateContextData(payload)
                .unwrap()
                .then((response) => {
                    setModelGenerateContextData(response?.context)
                })
                .catch((error) => {
                    console.error('API call failed:', error);
                });
        }
    }, [visible, generateContextData]);

    return (
        <div>
            <Modal
                className='contextModal'
                closable={true}
                centered
                open={visible}
                okText={okText}
                cancelText={cancelText}
                footer={null}
                onOk={onConfirm}
                onCancel={onCancel}
                width={534}
                maskClosable={false}
            >
                <div className="">
                    <div className="modal-header">
                        <h6 className="m-3 text-center">{title}</h6>
                    </div>
                    <div className="modal-body">
                        <div className="">
                            <p className="model-content">Description text about this alert is shown here, explaining to users what the options underneath</p>
                            <div className="content-wrapper">
                                {modelGenerateContextData && modelGenerateContextData?.map((item: any, index: number) => (
                                    <div className="d-flex justify-content-between mt-2" key={item?.col_key}>
                                        <div
                                            key={item?.col_key}
                                            className="content-editable"
                                            contentEditable="true"
                                            onBlur={(e) => handleBlur(e, item?.col_key)}
                                        >
                                        {item?.label}
                                        </div>
                                        <div className="">
                                            <p className="mb-0 non-editable-content">`{item?.col_key}`</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="button-wrapper">
                                <Button className="edit-proceed-button">edit & proceed</Button>
                            </div>
                        </div>
                        <div className="mt-4">
                            <p className="model-content">Description text about this alert is shown here, explaining to users what the options underneath</p>
                            <div className="content-wrapper">
                                <div className="">
                                    <p className="mb-0 non-editable-content">{debouncedValue?.map((item:any)=> <span>{item?.label}  {item?.col_key}: {item?.col_value}.</span>)} </p>
                                </div>
                                <div className="">

                                </div>
                            </div>
                            <div className="button-wrapper">
                                <Button className="proceed-button" onClick={onConfirm}>proceed</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}
export default memo(ContextModal);